import $ from 'jquery';
import aes from "crypto-js/aes";
import encHex from "crypto-js/enc-hex";
import padZeroPadding from "crypto-js/pad-zeropadding";
import CryptoJS from "crypto-js";

import API from '../API';

export const getPresignedUrl = (path) => {
    return process.env.REACT_APP_PROJPATH + "uploads/" + path
}

export function hideShow() {
    let body = document.getElementById('body');
    let wrapper = document.getElementById('wrapper');
    if (body.className.indexOf('fixed-left-void') !== -1) {
        body.classList.remove('fixed-left-void');
        wrapper.classList.remove('enlarged');
    }
    else {
        body.classList.add('fixed-left-void');
        wrapper.classList.add('enlarged');
    }
}

export function hide() {
    let body = document.getElementById('body');
    let wrapper = document.getElementById('wrapper');
    body.classList.add('fixed-left-void');
    wrapper.classList.add('enlarged');
}

export function collapseMenu() {
    $('.has_sub').each(function () {
        var t = $(this);
        if (t.hasClass('nav-active')) {
            t.find('> ul').slideUp(300, function () {
                t.removeClass('nav-active');
            });
        }
        else {
            t.find('> ul').slideDown(300, function () {
                t.addClass('nav-active');
            });
        }
    });
}

export function searchStringInArray(str, strArray) {
    for (var j = 0; j < strArray.length; j++) {
        if (strArray[j].match(str)) return j;
    }
    return -1;
}

export function get_hex(len) {
    const hex = "0123456789ABCDEF";
    let output = "";
    for (let i = 0; i < len; ++i) {
        output += hex.charAt(Math.floor(Math.random() * hex.length));
    }
    return output;
}

export function en(data) {
    const apiTest = process.env.REACT_APP_API_TEST;
    if (apiTest == 1) {
        return "" + data + "";
    }

    let uuid = get_hex(32);
    try {
        let text =
            data !== undefined && data !== null && data !== "" ? "" + data + "" : "";
        if (text === "") {
            return text;
        }

        let key = encHex.parse(process.env.REACT_APP_EN_ID1);
        let iv = "";
        if (
            uuid === "undefined" ||
            uuid === "null" ||
            uuid === undefined ||
            uuid === null ||
            uuid === ""
        ) {
            iv = encHex.parse(process.env.REACT_APP_EN_ID2);
        } else {
            iv = encHex.parse(uuid);
        }
        let en1 = aes
            .encrypt(text, key, { iv: iv, padding: padZeroPadding })
            .toString();

        return encodeURIComponent(window.btoa(en1 + "" + uuid));
    } catch (e) {
        return "";
    }
}

export function de(data) {
    const apiTest = process.env.REACT_APP_API_TEST;
    if (apiTest == 1) {
        return "" + data + "";
    }

    data = window.atob(decodeURIComponent(data));

    let uuid = data.slice(-32);
    data = data.substring(0, data.indexOf(uuid));
    try {
        let encrypted =
            data !== undefined && data !== null && data !== "" ? data : "";
        if (encrypted === "") {
            return encrypted;
        }

        let key = encHex.parse(process.env.REACT_APP_EN_ID1);
        let iv = "";
        if (
            uuid === "undefined" ||
            uuid === "null" ||
            uuid === undefined ||
            uuid === null ||
            uuid === ""
        ) {
            iv = encHex.parse(process.env.REACT_APP_EN_ID2);
        } else {
            iv = encHex.parse(uuid);
        }
        let de1 = aes
            .decrypt(encrypted, key, { iv: iv })
            .toString(CryptoJS.enc.Utf8);

        return de1;
    } catch (e) {
        return "";
    }
}

export function rtrim(str, chr) {
    var rgxtrim = !chr ? new RegExp("\\s+$") : new RegExp(chr + "+$");
    return str.replace(rgxtrim, "");
}

export function ltrim(str, chr) {
    var rgxtrim = !chr ? new RegExp("^\\s+") : new RegExp("^" + chr + "+");
    return str.replace(rgxtrim, "");
}

export function getFullScreenElement() {
    return document.getFullScreenElement || document.webkitFullscreenElement || document.mozFullscreenElement || document.msFullscreenElement;
}

export const uploadFileInChunks = async (file, storagePath, setProgress) => {
    if (!file) return;

    const chunkSize = 1024 * 1024;             // 1 MB per chunk
    const totalChunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    let timestamp = Date.now();


    while (currentChunk < totalChunks) {
        const start = currentChunk * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("file", chunk);
        formData.append("chunk", currentChunk);
        formData.append("totalChunks", totalChunks);
        formData.append("filename", file.name);
        formData.append("timestamp", timestamp);
        formData.append("storagePath", storagePath);

        try {
            const res = await API.post("/upload-chunk", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                // eslint-disable-next-line no-loop-func
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        // setProgress((prev) => Math.min((currentChunk / totalChunks) * 100, 100));
                    }
                },
            });
            if (res.data?.filePath) {
                return res.data?.filePath
            }
        } catch (error) {
            console.error("Error uploading chunk", error);
            throw new Error(error);
            // return error
            // break;
        }

        currentChunk++;
    }

    console.log("File uploaded successfully!");
};
